const CDN_BASE_URL = 'https://cdn.tap.company'
const TAP_ASSETS_PATH = '/tap-assets/icons/dashboard/light/country/'

const getCountryLogo = (country: string) => {
	return CDN_BASE_URL + TAP_ASSETS_PATH + country + '.svg'
}


export const BUSINESS_COUNTRIES = [
	{
		id: 1,
		title: 'Middle East',
		title_ar: 'الشرق الأوسط',
		countries: [
			{
				id: 1,
				label: 'sa',
				country: {
					id: 187,
					name_en: 'Saudi Arabia',
					name_ar: 'المملكة العربية السعودية',
					iso2: 'SA',
					iso3: 'SAU',
					idd_prefix: '966',
					logo: getCountryLogo('SA'), 
					min_digits: 10,
					max_digits: 10
				}
			},
			{
				id: 10,
				label: 'bh',
				country: {
					id: 16,
					name_en: 'Bahrain',
					name_ar: 'البحرين',
					iso2: 'BH',
					iso3: 'BHR',
					idd_prefix: '973',
					logo: getCountryLogo('BH'),
					min_digits: 8,
					max_digits: 8
				}
			},
			{
				id: 2,
				label: 'eg',
				country: {
					id: 63,
					name_en: 'Egypt',
					name_ar: 'مصر',
					iso2: 'EG',
					iso3: 'EGY',
					idd_prefix: '20',
					logo: getCountryLogo('EG'),
					min_digits: 10,
					max_digits: 10
				}
			},
			{
				id: 4,
				label: 'jo',
				country: {
					id: 107,
					name_en: 'Jordan',
					name_ar: 'الأردن',
					iso2: 'JO',
					iso3: 'JOR',
					idd_prefix: '962',
					logo: getCountryLogo('JO'),
					min_digits: 9,
					max_digits: 9
				}
			},
			{
				id: 5,
				label: 'kw',
				country: {
					id: 111,
					name_en: 'Kuwait',
					name_ar: 'الكويت',
					iso2: 'KW',
					iso3: 'KWT',
					idd_prefix: '965',
					logo: getCountryLogo('KW'),
					min_digits: 8,
					max_digits: 8
				}
			},
			{
				id: 11,
				label: 'lb',
				country: {
					id: 115,
					name_en: 'Lebanon',
					name_ar: 'لبنان',
					iso2: 'LB',
					iso3: 'LBN',
					idd_prefix: '961',
					logo: getCountryLogo('LB'),
					min_digits: 7,
					max_digits: 8
				}
			},
			{
				id: 12,
				label: 'om',
				country: {
					id: 155,
					name_en: 'Oman',
					name_ar: 'عمان',
					iso2: 'OM',
					iso3: 'OMN',
					idd_prefix: '968',
					logo: getCountryLogo('OM'),
					min_digits: 7,
					max_digits: 8
				}
			},
			{
				id: 13,
				label: 'qa',
				country: {
					id: 168,
					name_en: 'Qatar',
					name_ar: 'قطر',
					iso2: 'QA',
					iso3: 'QAT',
					idd_prefix: '974',
					logo: getCountryLogo('QA'),
					min_digits: 8,
					max_digits: 8
				}
			},
			{
				id: 14,
				label: 'ae',
				country: {
					id: 223,
					name_en: 'United Arab Emirates',
					name_ar: 'الإمارات العربية المتحدة',
					iso2: 'AE',
					iso3: 'ARE',
					idd_prefix: '971',
					logo: getCountryLogo('AE'),
					min_digits: 9,
					max_digits: 9
				}
			}
		]
	},
	{
		id: 2,
		title: 'Europe',
		title_ar: 'أوروبا',
		countries: [
			{
				id: 6,
				label: 'uk',
				country: {
					id: 224,
					name_en: 'United Kingdom',
					name_ar: 'المملكة المتحدة لبريطانيا العظمى وآيرلندا الشمالية',
					iso2: 'GB',
					iso3: 'GBR',
					idd_prefix: '44',
					logo: getCountryLogo('GB'),
					min_digits: 10,
					max_digits: 10
				}
			},
			{
				id: 7,
				label: 'ir',
				country: {
					id: 101,
					name_en: 'Ireland',
					name_ar: 'آيرلندا',
					iso2: 'IE',
					iso3: 'IRL',
					idd_prefix: '353',
					logo: getCountryLogo('IE'),
					min_digits: 10,
					max_digits: 10
				}
			},
			{
				id: 17,
				label: 'fr',
				country: {
					id: 73,
					name_en: 'France',
					name_ar: 'فرنسا',
					iso2: 'FR',
					iso3: 'FRA',
					idd_prefix: '33',
					logo: getCountryLogo('FR'),
					min_digits: 9,
					max_digits: 9
				}
			},
			{
				id: 18,
				label: 'nt',
				country: {
					id: 145,
					name_en: 'Netherlands',
					name_ar: 'هولندا',
					iso2: 'NL',
					iso3: 'NLD',
					idd_prefix: '31',
					logo: getCountryLogo('NL'),
					min_digits: 9,
					max_digits: 9
				}
			},
			{
				id: 19,
				label: 'gm',
				country: {
					id: 79,
					name_en: 'Germany',
					name_ar: 'ألمانيا',
					iso2: 'DE',
					iso3: 'DEU',
					idd_prefix: '49',
					logo: getCountryLogo('DE'),
					min_digits: 11,
					max_digits: 11
				}
			},
			{
				id: 20,
				label: 'sp',
				country: {
					id: 199,
					name_en: 'Spain',
					name_ar: 'إسبانيا',
					iso2: 'ES',
					iso3: 'ESP',
					idd_prefix: '34',
					logo: getCountryLogo('ES'),
					min_digits: 9,
					max_digits: 9
				}
			},
			{
				id: 21,
				label: 'it',
				country: {
					id: 103,
					name_en: 'Italy',
					name_ar: 'إيطاليا',
					iso2: 'IT',
					iso3: 'ITA',
					idd_prefix: '39',
					logo: getCountryLogo('IT'),
					min_digits: 11,
					max_digits: 11
				}
			}
		]
	},
	{
		id: 6,
		title: 'South Asia',
		title_ar: 'جنوب آسيا',
		countries: [
			{
				id: 15,
				label: 'pk',
				country: {
					id: 156,
					name_en: 'Pakistan',
					name_ar: 'باكستان',
					iso2: 'PK',
					iso3: 'PAK',
					idd_prefix: '92',
					logo: getCountryLogo('PK'),
					min_digits: 10,
					max_digits: 10
				}
			},
			{
				id: 16,
				label: 'in',
				country: {
					id: 97,
					name_en: 'India',
					name_ar: 'الهند',
					iso2: 'IN',
					iso3: 'IND',
					idd_prefix: '91',
					logo: getCountryLogo('IN'),
					min_digits: 10,
					max_digits: 10
				}
			}
		]
	},
	// {
	// 	id: 4,
	// 	title: 'East Asia',
	// 	countries: [
	// 		{
	// 			id: 8,
	// 			label: 'hk',
	// 			country: {
	// 				id: 45,
	// 				name_en: 'China, Hong Kong Special Administrative Region',
	// 				name_ar: 'منطقة هونغ كونغ الصينية الإدارية الخاصة',
	// 				iso2: 'HK',
	// 				iso3: 'HKG',
	// 				idd_prefix: '852',
	// 				logo: getCountryLogo('HK'),
	// 				min_digits: 8,
	// 				max_digits: 8
	// 			}
	// 		}
	// 	]
	// },
	{
		id: 5,
		title: 'South East Asia',
		title_ar: 'جنوب شرق آسيا',
		countries: [
			{
				id: 9,
				label: 'sg',
				country: {
					id: 192,
					name_en: 'Singapore',
					name_ar: 'سنغافورة',
					iso2: 'SG',
					iso3: 'SGP',
					idd_prefix: '65',
					logo: getCountryLogo('SG'),
					min_digits: 8,
					max_digits: 8
				}
			}
		]
	}
]